import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import legalData from "../data/legal.json";

export default function Legal() {
  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Terminos Legales | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="legal" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Terminos Legales</h1>
        </div>
        <div className="content-main">
        {legalData.map((legal) => (
            <div className="legal-wrapper">
              <div className="legal title">{legal.id+". "+legal.title}</div>
              <div className="legal text">{legal.description}</div>
            </div>
         ))}
        </div>
      </div>
    </div>
  </>
  );
}
